import { useFetch } from './useFetch'
import type { TenantGroupDTO } from '../types'

export function useTenantGroup(id: string) {
  const { data: tenantGroup, isLoading, error } =
    useFetch<TenantGroupDTO | null>(`/v1/tenant-groups/${id}`, null)
  return { tenantGroup, isLoading, error }
}
